import { useEffect, useState } from 'react';

export const useMediaQuery = (limitInPx: number, isMaxWidth = true) => {
  const mediaMatch = window.matchMedia(
    `${isMaxWidth ? '(max-width:' : '(min-width:'}${limitInPx}px)`,
  );
  const [matches, setMatches] = useState(mediaMatch.matches);

  useEffect(() => {
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    mediaMatch.addEventListener('change', handler);
    return () => mediaMatch.removeEventListener('change', handler);
  });
  return matches;
};
